import React from 'react';
import { useParams } from 'react-router-dom';
import EnhancedEmergencyContacts from '../../components/EmergencyContacts/EnhancedEmergencyContacts';

const EmergencyContacts = ({ patientId: propPatientId, role = 'doctor' }) => {
  const { id: paramPatientId } = useParams();
  const finalPatientId = propPatientId || paramPatientId;

  return (
    <EnhancedEmergencyContacts patientId={finalPatientId} role={role} />
  );
};

export default EmergencyContacts; 